// Weber.com-style hover magnifier: a round lens follows the cursor over the main product image
// and shows that spot at 2x. Enabled per template by the "weber_lightbox" section setting.

const containerSelector = '[data-weber-hover-zoom] .product-media-container.media-type-image';
const zoomFactor = 1.5;
const openDuration = 180;
const closeDuration = 210;
const desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

let activeContainer = null;
let lens = null;
let lensImage = null;

/**
 * Creates the lens element for a product image and adds it to the page.
 *
 * @param {HTMLElement} container - The product media container being hovered.
 * @returns {void}
 */
const openLens = (container) => {
  const sourceImage = container.querySelector('.product__media img');
  if (!sourceImage) return;

  activeContainer = container;
  lens = document.createElement('div');
  lens.className = 'zoom-lens zoom-lens--opening zoom-lens--loading';
  lens.setAttribute('aria-hidden', 'true');

  lensImage = document.createElement('img');
  lensImage.alt = '';
  lensImage.onload = () => lens?.classList.remove('zoom-lens--loading');
  lensImage.src = container.dataset.zoomSrc || sourceImage.currentSrc || sourceImage.src;

  lens.appendChild(lensImage);
  document.body.appendChild(lens);

  const openingLens = lens;
  setTimeout(() => openingLens.classList.remove('zoom-lens--opening'), openDuration);
};

/**
 * Centers the lens on the cursor and pans the zoomed image to the matching spot.
 *
 * @param {MouseEvent} event - The mouse event carrying the cursor position.
 * @returns {void}
 */
const moveLens = (event) => {
  const sourceImage = activeContainer.querySelector('.product__media img');
  const rect = sourceImage.getBoundingClientRect();
  const x = Math.min(Math.max(event.clientX - rect.left, 0), rect.width);
  const y = Math.min(Math.max(event.clientY - rect.top, 0), rect.height);
  const halfLens = lens.offsetWidth / 2;

  lens.style.left = `${event.pageX - halfLens}px`;
  lens.style.top = `${event.pageY - halfLens}px`;
  lensImage.style.width = `${rect.width * zoomFactor}px`;
  lensImage.style.height = `${rect.height * zoomFactor}px`;
  lensImage.style.transform = `translate(${halfLens - x * zoomFactor}px, ${halfLens - y * zoomFactor}px)`;
};

/**
 * Plays the closing animation on the current lens, then removes it.
 *
 * @returns {void}
 */
const closeLens = () => {
  if (!lens) return;

  const closingLens = lens;
  closingLens.classList.remove('zoom-lens--opening');
  closingLens.classList.add('zoom-lens--closing');
  setTimeout(() => closingLens.remove(), closeDuration);

  activeContainer = null;
  lens = null;
  lensImage = null;
};

/**
 * Opens, moves or closes the lens depending on which product image is under the cursor.
 * Uses delegation so it keeps working after the gallery is re-rendered on variant change.
 *
 * @param {MouseEvent} event - The document mousemove event.
 * @returns {void}
 */
const handleMouseMove = (event) => {
  const container = desktopQuery.matches ? event.target.closest(containerSelector) : null;

  if (container !== activeContainer) {
    closeLens();
    if (container) openLens(container);
  }

  if (activeContainer) moveLens(event);
};

document.addEventListener('mousemove', handleMouseMove, { passive: true });
document.addEventListener('click', closeLens);
window.addEventListener('scroll', closeLens, { passive: true });
